export const SUBMIT_TAX_RATE_CHANGES = 'SUBMIT_TAX_RATE_CHANGES';
export const SUBMIT_TAX_RATE_CHANGES_SUCCESS = 'SUBMIT_TAX_RATE_CHANGES_SUCCESS';
export const SUBMIT_TAX_RATE_CHANGES_FAILED = 'SUBMIT_TAX_RATE_CHANGES_FAILED';

export const FETCH_TAX_RATE_CHANGES = 'FETCH_TAX_RATE_CHANGES';
export const FETCH_TAX_RATE_CHANGES_SUCCESS = 'FETCH_TAX_RATE_CHANGES_SUCCESS';
export const FETCH_TAX_RATE_CHANGES_FAILED = 'FETCH_TAX_RATE_CHANGES_FAILED';
